import * as React from "react";
import Box from "@mui/material/Box";
import CancelledTable from "./CancelledTable";
import ActiveTable from "./ActiveTable";
import ExpiredTable from "./expiredTable";
import CustomTabs from "../tabs";

export default function BasicTabs({
  activeSubscriptions = [],
  cancelledSubscriptions = [],
  subscriptionStatus,
  expiredSubscriptions = [],
}) {
  const [tabKey, setTabKey] = React.useState("1");

  const tabs = [
    {
      label: "Active",
      key: "1",
    },
    {
      label: "Cancelled",
      key: "2",
    },
    {
      label: "Expired",
      key: "3",
    },
  ];

  return (
    <Box sx={{ width: "100%" }}>
      <CustomTabs
        items={tabs}
        activeKey={tabKey}
        onTabChange={(v) => setTabKey(v)}
        style={{
          marginBottom: 20,
        }}
      />
      {tabKey === "1" && (
        <ActiveTable
          data={activeSubscriptions}
          subscriptionStatus={subscriptionStatus}
        />
      )}
      {tabKey === "2" && <CancelledTable data={cancelledSubscriptions} />}
      {tabKey === "3" && <ExpiredTable data={expiredSubscriptions} />}
    </Box>
  );
}
